import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true); toast.success("Cek email Anda.");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-sm space-y-5">
        <h1 className="text-3xl font-semibold text-slate-900">Lupa Password</h1>
        <p className="text-sm text-slate-500">Masukkan email @gmail.com Anda. Kami akan mengirim link reset password.</p>
        {sent ? (
          <div className="p-4 border border-emerald-200 bg-emerald-50 text-sm text-emerald-800 rounded-sm">
            Jika email terdaftar, link reset password telah dikirim ke {email}.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div className="space-y-2">
              <Label>Email</Label>
              <Input data-testid="forgot-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required/>
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full brand-btn rounded-sm">
              {loading ? "Mengirim..." : "Kirim Link Reset"}
            </Button>
          </form>
        )}
        <div className="text-sm">
          <Link to="/login" className="text-[color:var(--brand)] hover:underline">← Kembali ke Login</Link>
        </div>
      </div>
    </div>
  );
}
